import React from 'react'
import logo from "../Logo.png";

function Load() {

    return (
        <div className='loading'>
            <img className='img-loading'src={logo} alt=""  />
        </div>
    )
}

export default Load
